import CONTRATOACTIVIDADES from '@/graphql/querys/administracion/contratos/contrato/reporteactividades/contratoActividades.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';

export default {

  apollo: {
    contratoActividades: {
      query: CONTRATOACTIVIDADES,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.idContrato,
        };
      },
    },
  },
  methods: {
    cuentaTotalImagenes(frentes) {
      let totalImagenes = 0;
      frentes.map((f) => {
        totalImagenes += f.imagenes.length;
        return true;
      });
      return totalImagenes;
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getNumeroContrato() {
      if (!this.getContrato) return 'SinNumero';
      return this.getContrato.numero;
    },
    getAlbum() {
      if (!this.contratoActividades) return [];
      const actividades = this.contratoActividades
        .map((a) => ({
          fecha: a.fecha,
          imagenes: a.imagenes,
          idFrente: a.frente.id || '',
          descripcionFrente: a.frente.descripcion || '',
          ordenFrente: a.frente.orden || 1000,
          relevancia: a.tipo || 1,
        }));
      const frentesTodos = this.contratoActividades
        .map((a) => ({
          frente: a.frente.descripcion,
          idfrente: a.frente.id,
          orden: a.frente.orden,
        }))
        .sort((a, b) => a.orden - b.orden);
      const frentes = frentesTodos
        .map((item) => item.frente);
      const frentesUnicos = frentes
        .filter((item, index) => frentes.indexOf(item) === index);

      const imagenes = [];
      frentesUnicos.forEach((f) => {
        actividades.filter((a) => a.descripcionFrente === f)
          .map((a) => {
            a.imagenes.forEach((i) => {
              imagenes.push({
                frente: f,
                fecha: a.fecha,
                imagen: i,
                relevancia: a.relevancia,
              });
            });
            return true;
          });
      });
      imagenes.sort((a, b) => new Date(`${a.fecha} 00:00:0`) - new Date(`${b.fecha} 00:00:0`));
      const tipo = [
        { tipo: 'Album', relevancia: 3, modulos: ['consultas', 'ejecucion'] },
        { tipo: 'Informe', relevancia: 2, modulos: ['ejecucion'] },
        { tipo: 'Diario', relevancia: 1, modulos: ['ejecucion'] },
      ];

      let imagenesFrentesUnicos = [];
      const carretes = tipo.map((t) => {
        imagenesFrentesUnicos = frentesUnicos
          .map((f) => ({
            descripcion: f,
            imagenes: [...imagenes.filter((i) => i.frente === f && i.relevancia === t.relevancia)
              .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`))],
            totalImagenes: [...imagenes
              .filter((i) => i.frente === f && i.relevancia === t.relevancia)].length,
          }))
          .filter((i) => i.totalImagenes > 0);
        return {
          relevancia: t.tipo,
          modulos: t.modulos,
          totalImagenes: this.cuentaTotalImagenes(imagenesFrentesUnicos),
          frentes: imagenesFrentesUnicos,
        };
      });
      return carretes.filter((item) => item.totalImagenes > 0);
    },
  },
};
